import { render, staticRenderFns } from "./UsersEdit.vue?vue&type=template&id=071645bf"
import script from "./UsersEdit.vue?vue&type=script&lang=ts"
export * from "./UsersEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports